export enum DiffBenchmark {
   UTILITY = "UTILITY",
   COMMUNITY = "COMMUNITY"
}